import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=71106bb8&scoped=true"
import script from "./ParticipantList.vue?vue&type=script&lang=js"
export * from "./ParticipantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71106bb8",
  null
  
)

export default component.exports